export default __webpack_public_path__ + "static/media/emenu-bg-rtl.9dd265b7.webp";